export default function Team() {
  return null;
}
